import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import RemoveIcon from "@mui/icons-material/Remove";
import { useColoresGrafico } from "../utils/colores";

// Ficha de un indicador: etiqueta, valor, y (opcional) variación contra el periodo anterior. El color de la variación se acompaña siempre con
// flecha y texto (nunca solo color). `masEsBueno=false` invierte el sentido (p. ej. una cartera que sube es mala).
export default function KpiTile({ etiqueta, valor, detalle, variacion, referencia, masEsBueno = true, icono }) {
  const c = useColoresGrafico();
  let delta = null;
  if (variacion !== undefined) {
    if (variacion === null) {
      delta = <Typography sx={{ fontSize: 12, color: "text.secondary" }}>Sin dato del {referencia}</Typography>;
    } else {
      const sube = variacion > 0.05;
      const baja = variacion < -0.05;
      const bueno = (sube && masEsBueno) || (baja && !masEsBueno);
      const color = !sube && !baja ? "text.secondary" : bueno ? c.buenoTexto : c.malo;
      const Icono = sube ? ArrowUpwardIcon : baja ? ArrowDownwardIcon : RemoveIcon;
      delta = (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap" }}>
          <Box sx={{ display: "inline-flex", alignItems: "center", color, fontWeight: 700, fontSize: 12.5 }}>
            <Icono sx={{ fontSize: 15 }} />
            {`${variacion > 0 ? "+" : ""}${variacion.toLocaleString("es-BO", { maximumFractionDigits: 1 })}%`}
          </Box>
          <Typography sx={{ fontSize: 12, color: "text.secondary" }}>vs. {referencia}</Typography>
        </Box>
      );
    }
  }

  return (
    <Paper variant="outlined" sx={{ p: 1.75, display: "flex", flexDirection: "column", gap: 0.5, minWidth: 0 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, color: "text.secondary" }}>
        {icono}
        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{etiqueta}</Typography>
      </Box>
      <Typography sx={{ fontSize: 26, fontWeight: 700, lineHeight: 1.15, letterSpacing: "-0.01em" }}>{valor}</Typography>
      {detalle && <Typography sx={{ fontSize: 12.5, color: "text.secondary" }}>{detalle}</Typography>}
      {delta}
    </Paper>
  );
}
